<template>
  <el-input
    v-model="computedValue"
    placeholder="请输入"
    type="textarea"
    :autosize="{ minRows: 3 }"
    :maxlength="config.baseQuestionLimitMax || undefined"
    :disabled="!editable"
  ></el-input>
</template>

<script>
import CompMix from "../../mixins/comp-mix";
export default {
  mixins: [CompMix],
};
</script>

<style lang="scss" scoped></style>
